import React from 'react';

import maerskLogo from '../../images/maersk-logo.png';
import './top-bar.css';

const Header = ({ language, onLanguageChange, userName, userPhotoUrl, onGoToDashboard }) => {
  const initials = userName
    ? userName.split(" ").map((n) => n[0]).slice(0, 2).join("").toUpperCase()
    : "";

  const headerStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    top: 0,
    zIndex: 1000,
    width: '100%',
    height: '60px',
    position: 'fixed',
    left: 0,
    color: '#ffffff',
    background: 'linear-gradient(105deg, #03111f 0%, #04304d 35%, #075e82 70%, #0a8fa8 100%)',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    fontFamily: 'Maersk Text',
  };

  return (
    <header className="custom-header" style={headerStyles}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img src={maerskLogo} alt="Company Logo" style={{ height: '26px', marginRight: '20px' }} />
        <div className="productName" style={{ marginLeft: '8px' }}>
          Approval Freight Release
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginRight: '20px' }}>

        {onGoToDashboard && (
          <button
            onClick={onGoToDashboard}
            style={{
              background: 'rgba(255,255,255,0.15)', color: '#fff',
              border: '1px solid rgba(255,255,255,0.35)',
              borderRadius: '6px', padding: '6px 14px', fontSize: '0.82rem',
              fontWeight: 500, cursor: 'pointer', whiteSpace: 'nowrap',
            }}
          >
            Dashboard
          </button>
        )}

        {userName && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ fontSize: '0.82rem', color: '#ffffff', fontWeight: 500, whiteSpace: 'nowrap' }}>
              {userName}
            </span>
            {userPhotoUrl ? (
              <img
                src={userPhotoUrl}
                alt={userName}
                style={{
                  width: '32px', height: '32px', borderRadius: '50%',
                  border: '1.5px solid rgba(255,255,255,0.5)',
                  objectFit: 'cover', flexShrink: 0,
                }}
              />
            ) : (
              <div style={{
                width: '32px', height: '32px', borderRadius: '50%',
                background: 'rgba(255,255,255,0.2)', color: '#fff',
                border: '1.5px solid rgba(255,255,255,0.5)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: '0.72rem', fontWeight: 600, flexShrink: 0,
              }}>
                {initials}
              </div>
            )}
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
